import { coreService } from "../../../../services/coreService";
import { buildQuery } from "../../../../lib/network";

export type InspectionGetByIdRes = Awaited<ReturnType<typeof coreService.inspectionsDetail>>["data"];
export const getInspection =
  (headers: any) => (key: any, inspectionId: number, previousItemStatus?: "passed" | "failed" | "incomplete") => {
    return buildQuery(
      coreService.inspectionsDetail(inspectionId, { previousItemStatus: previousItemStatus }, { headers: headers }),
      (response) => {
        return response.data;
      },
    );
  };
